import useCurrentOrganizationInfo from '../../hooks/useCurrentOrganizationInfo';
import { ADD_ONS_PRODUCT_BASE_NAME } from '../subscriptionComponents/subscriptionHelper';
import {
  AddAddonCart,
  GetAllCartProductList,
  removeAllItemsFromCart,
} from '../../api/subscription/subscription';
import stylesInvite from '../../components/popups/SentInvite.module.scss';
import popupStyles from '../../components/popups/UpgradeForMore.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { SETTINGS_TAB } from '../../constants/constants';
import { openFormInCaseOfNewOrgAndFreemiumUser, windowOpen } from '../../helpers/jsHelper';
import {
  selectAddonsList,
} from '../../redux/slicers/subscriptionSlicer';
import { setShowEditorNudge } from '../../redux/slicers/productV2Slicer';
import { CrossIcon, PlusIcon } from '../../assets/icons';
import Button from '../../components/Button';
import MinusIcon from '../../components/icons/MinusIcon';
import { ADMIN_SETTINGS } from '../../constants/routePathConstants';

export const EditorNudge = () => {
  const dispatch = useDispatch();
  const [editorCnt, setEditorCnt] = useState(1);
  const { isFreemiumOrSelfServeUser, hideNewPlans } = useCurrentOrganizationInfo();
  const { results: addonsList } = useSelector(selectAddonsList);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (hideNewPlans) { // open enterprise form in case of freemium user whose org is created after 10th Feb 2025
      openFormInCaseOfNewOrgAndFreemiumUser();
      onClose();
    }
  }, [hideNewPlans]);

  const onClose = () => {
    dispatch(setShowEditorNudge(false));
  };

  const handleButtonClick = async () => {
    if (isFreemiumOrSelfServeUser) {
      openFormInCaseOfNewOrgAndFreemiumUser();
      // setLoading(true);
      // await dispatch(GetAllCartProductList());
      // await removeAllItemsFromCart();
      // setLoading(false);

      // windowOpen(
      //   `${ADMIN_SETTINGS}?activeTab=${SETTINGS_TAB.PLANS}&editors=${editorCnt}`,
      //   '_blank'
      // );
    } else {
      await buyEditors();
    }
    onClose();
  };

  const buyEditors = async () => {
    setLoading(true);
    await dispatch(GetAllCartProductList());
    const addonsItem = addonsList?.find(
      ({ basemodeltype }) => basemodeltype === ADD_ONS_PRODUCT_BASE_NAME['Editor']
    );
    let payload = {
      subscription_price: addonsItem?.id,
      quantity: editorCnt,
    };
    await removeAllItemsFromCart();
    const response = await AddAddonCart(payload, 'add');
    if (response?.status) {
      windowOpen(
        `${ADMIN_SETTINGS}?activeTab=${SETTINGS_TAB.PLANS}&checkout=true&is_one_time=false&referrer=${window.location.href}`,
        '_blank'
      );
    }
    setLoading(false);
  };

  const onIncreaseDecreaseCount = (type) => {
    if (
      loading ||
      (type === 'decrease' && editorCnt < 2) ||
      (type === 'increase' && editorCnt > 100)
    )
      return;
    const count = type === 'decrease' ? editorCnt - 1 : editorCnt + 1;
    setEditorCnt(count);
  };

  const handleContinueClick = () => {
    onClose();
  };

  if (hideNewPlans) { // hide this in case of freemium user whose org is created after 10th Feb 2025
    return null;
  }

  return (
    <div className={`${popupStyles.container} d-flex`}>
      <div className={popupStyles.closeIcon} onClick={onClose}>
        <CrossIcon />
      </div>
      <div className={`${popupStyles.wrapper} ${stylesInvite.wrapper} bg-white`}>
        <div className="w-100 h-100 d-flex flex-column" style={{ gap: '24px' }}>
          <div className={`${popupStyles.action}`} style={{ gap: '12px' }}>
            <div className={popupStyles.subTitle}>
              You don&apos;t have editor access. Please buy editors.
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <div className={popupStyles.title}>Editors</div>
              <Button
                disabled={loading}
                className={`${stylesInvite.selectionButton} cursor-pointer ${stylesInvite.addToCartBtn}`}>
                <MinusIcon
                  onClick={() => onIncreaseDecreaseCount('decrease')}
                  fill="var(--dust-800)"
                />
                <input
                  type="number"
                  onChange={(e) => e.preventDefault()}
                  value={editorCnt}
                  disabled
                />
                <PlusIcon
                  onClick={() => onIncreaseDecreaseCount('increase')}
                  className={stylesInvite.icon}
                  fill="var(--dust-800)"
                />
              </Button>
            </div>
          </div>
          <div className="w-100 d-flex gap-2">
            <Button
              className="w-50 p-3"
              size="xs"
              onClick={handleButtonClick}
              loading={loading}
              disabled={loading}>
              Add now ($99/editor)
            </Button>
            <Button className="w-50 p-3" size="xs" color="secondary" onClick={handleContinueClick}>
              Continue without editor
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
